
import React, { Component, ErrorInfo, ReactNode } from "react";
import { ErrorState } from "./ErrorState";
import { reportError } from "@/utils/monitoring";

interface Props {
  children: ReactNode;
  componentName?: string; // Optional component name for better error context
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Report to Sentry with component context
    reportError(error, {
      componentStack: errorInfo?.componentStack,
      componentName: this.props.componentName || 'UnnamedComponent'
    });
    
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title="Something went wrong"
          description={this.state.error?.message || "An unexpected error occurred."}
          onRetry={() => {
            this.setState({ hasError: false, error: null });
            window.location.reload();
          }}
        />
      );
    }

    return this.props.children;
  }
}
